module.exports = function() {
  return new Worker(__webpack_public_path__ + "6d04e006426c5efc471e.worker.js");
};